'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A simple container for layout that adds margins to the sides.
 */
var SpacerContainer = function SpacerContainer(_ref) {
  var all = _ref.all,
    left = _ref.left,
    top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    children = _ref.children;
  var spacerContainerClassNames = (0, _classnames2.default)({
    'u-spacer-l': all === 'large',
    'u-spacer': all === 'medium',
    'u-spacer-s': all === 'small',
    'u-spacer-left-l': left === 'large',
    'u-spacer-left': left === 'medium',
    'u-spacer-left-s': left === 'small',
    'u-spacer-top-l': top === 'large',
    'u-spacer-top': top === 'medium',
    'u-spacer-top-s': top === 'small',
    'u-spacer-right-l': right === 'large',
    'u-spacer-right': right === 'medium',
    'u-spacer-right-s': right === 'small',
    'u-spacer-bottom-l': bottom === 'large',
    'u-spacer-bottom': bottom === 'medium',
    'u-spacer-bottom-s': bottom === 'small'
  });
  return _react2.default.createElement('div', {
    className: spacerContainerClassNames
  }, children);
};
SpacerContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Adds margin on all sides of container*/
  all: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Adds margin on left side of container*/
  left: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Adds margin on top side of container*/
  top: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Adds margin on right side of container*/
  right: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Adds margin on bottom side of container*/
  bottom: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Children of the container */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = SpacerContainer;